import transformSecurityQuestion from '../AccountResource/transformSecurityQuestion';
import { SecurityQuestionsDto } from '../../interfaces/Dto/SecurityQuestionsDto';
import { SecurityQuestions } from '../../interfaces/SecurityQuestions';
import transformSecurityQuestionsBehaviours from './transformSecurityQuestionsBehaviours';

export default function transformSecurityQuestions(securityQuestionsDto: SecurityQuestionsDto): SecurityQuestions {
  const securityQuestions = {
    data: securityQuestionsDto?.data?.map(transformSecurityQuestion),
    behaviours: securityQuestionsDto ? transformSecurityQuestionsBehaviours(securityQuestionsDto.behaviours) : undefined,
  };
  return securityQuestions;
}
